var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"col-span-full",attrs:{"title":_vm.$t(_vm.$route.name) + ' - ' + _vm.$t('QUALITY_TITLE') + ': ' + _vm.qualityTitle,"router":{
    name: 'REPORT_OVERVIEW_v3',
  }}},[(!!_vm.result)?_c('div',{staticClass:"\n      flex\n      lg:gap-12\n      gap-6\n      flex-col\n      lg:flex-row\n      items-start\n      justify-start\n    "},[_c('Field',{attrs:{"title":_vm.$t('VEHICLE_TITLE'),"type":"col","align":"start"}},[_c('LicensePlate',{attrs:{"type":"dashboard","vehicle":_vm.result.company_vehicle.vehicle,"color":_vm.result.company_vehicle.color,"license_plate":_vm.result.company_vehicle.license_plate,"chars":_vm.alphaList}})],1),(_vm.result.company_vehicle.driver)?_c('Field',{attrs:{"title":_vm.$t('DRIVER_TITLE'),"type":"col","align":"start"}},[_c('p',[_vm._v(" "+_vm._s(_vm.result.company_vehicle.driver.first_name + ' ' + _vm.result.company_vehicle.driver.last_name)+" ")])]):_vm._e(),_c('Field',{attrs:{"title":_vm.$t('DURATION') + ' (' + _vm.$t('HOUR') + ')',"type":"col","align":"start"}},[_c('span',[_vm._v(" "+_vm._s(_vm.calculateHour(_vm.result.route.duration))+" ")])]),_c('Field',{attrs:{"title":_vm.$t('ODOMETER'),"type":"col","align":"start"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.numberSeperator1(_vm.result.route.length / 1000))}})])],1):_vm._e(),(!!_vm.result)?_c('overview-detail-map',{attrs:{"route":_vm.result.route}}):_vm._e(),(!!_vm.result)?_c('Content',{staticClass:"col-span-full mt-8",attrs:{"childClass":"border-whitee","title":"SPEED_GRAPH","showBreadcrumb":false,"showAdd":false}},[_c('VueApexCharts',{attrs:{"type":"line","height":"350","options":{
        chartOptions: _vm.chartOptions,
        labels: _vm.date,
        annotations: {
          yaxis: [
            {
              y: _vm.result.route.max_speed,
              borderColor: '#b30000',
              label: {
                borderColor: '#b30000',
                textAnchor: 'start',
                style: {
                  color: '#fff',
                  background: '#b30000',
                },
                text: ((_vm.$t('MAX_SPEED')) + ": " + (_vm.result.route.max_speed) + "km/h"),
              },
            },
            {
              y: _vm.result.route.mean_speed,
              borderColor: '#d0aa00',
              label: {
                borderColor: '#d0aa00',
                textAnchor: 'start',
                style: {
                  color: '#fff',
                  background: '#d0aa00',
                },
                text: ((_vm.$t('AVG_SPEED')) + ": " + (_vm.result.route.mean_speed) + "km/h"),
              },
            } ],
        },
        points: [
          {
            x: new Date('01 Dec 2017').getTime(),
            y: _vm.result.route.max_speed,
            marker: {
              size: 8,
              fillColor: '#fff',
              strokeColor: 'red',
              radius: 2,
              cssClass: 'apexcharts-custom-class',
            },
            label: {
              borderColor: '#FF4560',
              offsetY: 0,
              style: {
                color: '#fff',
                background: '#FF4560',
              },

              text: 'Point Annotation',
            },
          } ],
      },"series":_vm.speeds}})],1):_vm._e(),(!!_vm.result && _vm.hasTemperatureData)?_c('Content',{staticClass:"col-span-full mt-8",attrs:{"childClass":"border-whitee","title":"temperature_chart","showBreadcrumb":false,"showAdd":false}},[_c('VueApexCharts',{attrs:{"type":"line","height":"350","options":{
        chartOptions: _vm.chartOptions,
        labels: _vm.date,
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
          },
          custom: this.customTooltip,
        },
      },"series":_vm.temperatures}})],1):_vm._e(),(!!_vm.result && _vm.hasFuelData)?_c('Content',{staticClass:"col-span-full mt-8",attrs:{"childClass":"border-whitee","title":"fuel_chart","showBreadcrumb":false,"showAdd":false}},[_c('VueApexCharts',{attrs:{"type":"line","height":"350","options":{
        chartOptions: _vm.chartOptions,
        labels: _vm.date,
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
          },
          custom: this.customFuelTooltip,
        },
      },"series":_vm.fuels}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }